module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/29f6558a07459c1787681f11e59eeb6c.png";